<template>
	<div>
		<a-modal v-show='!ishand' id='val_cope' width='41rem' v-model="visible" on-ok="handleOk1"
			v-dragModal :dialog-style="{ top: 23 +'vh' }"
			@cancel="handleCancel(0)" :footer="null" :keyboard='false' :maskClosable='false'>
			<div class='mark-file'>
				<div
					style="background-color: #0c8b97;border-radius:  10px 10px 0 0;color: #fff;width: 39rem;margin: 1rem 1rem 0 1rem;text-align: center;">
					查看詳情
				</div>
			</div>
			<div solt='title' style="position: relative;">
				<!-- <div style="position: absolute;top: 0;left: 0;background-color: red;">標題</div> -->
			</div>
			<div style="paddingBottom: 1rem;border-radius: 0 0 10px 10px;padding: 1rem;background-color: #fff;
			width: 39rem;margin: 0 auto;marginBottom: 1rem;">
				<div style="padding-top: 1.5rem;">
					<div style="display:flex;justify-content: space-between;">
						<div class='look_g'><div></div>中文</div>
						<div>
							<img :src="require('../../../image/fuzhi.png')" alt=""
							  @click='copyText("one_cope")' >
						</div>
					</div>
						<a-row id='one_cope'>
							<a-col :span='12'>證券帳號：{{itemobj.number}}</a-col>
							<a-col :span='12'>帳號名稱：{{itemobj.name}}</a-col>
							<a-col :span='24'>中文連結：{{itemobj.url_cn}}</a-col>
							<a-col :span='24'>英文連結：{{itemobj.url_en}}</a-col>
						</a-row>
						<div class='main-wid'></div>
						<div style="display:flex;justify-content: space-between;">
							<div class='look_g'><div></div>ENG</div>
							<div>
								<img :src="require('../../../image/fuzhi.png')" alt=""
								  @click='copyText("two_cope")' >
							</div>
						</div>
						<a-row id='two_cope'>
							<a-col :span='12'>Account ID：{{itemobj.number}}</a-col>
							<a-col :span='12'>Account Name：{{itemobj.name}}</a-col>
							<a-col :span='24'>Chinese link：{{itemobj.url_cn}}</a-col>
							<a-col :span='24'>Emglish link：{{itemobj.url_en}}</a-col>
						</a-row>
				</div>
			</div>
			<div style="width: 100%;height: 1px;"></div>
		</a-modal>
	</div>
</template>

<script>
	import App from '@/assets/app.js';
	export default {
		props: ['itemobj'],
		data() {
			return {
				loading:true,
				ishand: false,
				visible: true,
				form: {
					"token":"",
					 "inviterid":"",
					 "name":"",
					 "number":"",
					 "status":''
				},
			}
		},
		mounted() {
		},
		methods: {
			copyText(dome) {
				let domelist = document.getElementById(dome).children
				var str = ''
				// for(let a = 0 ; a<domelist.length;a++){
				// 	console.log(domelist[a].innerHTML,dome)
				// 	str += domelist[a].innerHTML + '\n';
				// }
				let cname = dome == 'one_cope'? ' 中文':' Chinese' ;
				let ename = dome == 'one_cope'?' 英文':' Emglish';
				let tname = dome == 'one_cope'?'邀請開戶連結：' :'Invitation of Account Open link：';
				str += domelist[0].innerHTML + '\n';
				str += domelist[1].innerHTML + '\n\n';
				str += tname + '\n';
				str += this.itemobj.url_cn + cname +'\n';
				str += this.itemobj.url_en + ename +'\n';
				// console.log(str)
				var input = document.getElementById("input");
				input.value = str||''; 		  // 修改文本框的内容
				input.select(); 	   		  // 选中文本
				document.execCommand("copy"); // 执行浏览器复制命令
				if (str) {
					// alert("复制成功");
					this.$message.success('復制成功')
				} else {
					clipboardData.clearData("Text")
					this.$message.warning('沒有鏈接')
				}
			},
			handleCancel(ev) {
				this.$emit('child', 0)
			},
			handleOk1() {

			}
		}
	}
</script>

<style lang="scss">
	#val_cope .ant-modal-header,
	#val_cope .ant-modal-body {
		background-color: #e5e5e5 !important;
		padding: 1rem;
		padding-top: 0.7rem;
	}

	.mark-file {
		position: absolute;
		top: 0;
		left: 0;

		div {
			width: 6rem;
			font-size: 1rem;
			padding: .5rem 1rem;
			display: inline-block;
		}
	}

	#val_cope {
		.ant-col{
			font-size: .8rem;
			color: #333;
			margin: .5rem 0;
		}
		.main-wid{
			width: 100%;
			height: 1px;
			border-top: .5px solid #d8d8d8;
			margin: 1rem 0;
		}
		.look_g{
			font-size: .9rem;
			margin-bottom: .5rem;
			color: #0c8b97;
			div{
				display: inline-block;
				width: 1px;
				height: .9rem;
				position: relative;
				top: .1rem;
				margin-right: .2rem;
				border-left: 3px solid #0c8b97;
			}
		}
		.ant-form-explain{
			display: none;
		}

		.ant-modal-content {
			border-radius: 10px;
		}
	
		.ant-modal-body {
			padding: 0;
			padding-top: 2.5rem;
		}
	}
</style>
